import { useEffect } from 'react';

/**
 * Prevents the browser Back button from leaving the current route
 * (avoids history flicker / tab title changes).
 */
const useDisableBrowserBack = () => {
  useEffect(() => {
    const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    window.history.pushState({ disableBrowserBack: true }, '', url);

    const handlePopState = () => {
      window.history.pushState({ disableBrowserBack: true }, '', url);
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
};

export default useDisableBrowserBack;
